@if (insurance) {
  <div class="grid-container margin-top">
    <h2>Insurance - {{ organization?.name }}</h2>
    <div class="grid-x grid-margin-x grid-margin-y">
      <div class="cell medium-12">
        <label class="bold">Id:</label>
        {{ insurance.id }}
      </div>
      <div class="cell medium-4">
        <div class="bold">Agency:</div>
        {{ insurance.agency }}
      </div>
      <div class="cell medium-4">
        <label class="bold">Agent:</label>
        {{ insurance.agent }}
      </div>
      <div class="cell medium-4">
      </div>
      <div class="cell small-4">
        <label class="bold">Phone:</label>
        {{ phoneFormatter(insurance.phoneNumber) }}
      </div>
      <div class="cell small-4">
        <label class="bold">Email:</label>
        {{ insurance.emailAddress }}
      </div>
      <div class="cell small-4">
      </div>
      <div class="cell small-12">
        <ag-grid-angular [gridOptions]="gridOptions" [rowData]="insurance.policies"  class="data-grid " aria-label="Fa Insurance Details"></ag-grid-angular>
      </div>
    </div>
  </div>
}

@if (!insurance) {
  <div class="margin-top margin-left">
    <h2>Could not load insurance</h2>
  </div>
}